import styled from 'styled-components'

import { button } from 'components/Editor/styled/Button'

const ResultItemStyled = styled.button<{ $disabled?: boolean }>`
  ${button}
  border-radius: 6px;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  display: flex;
  border-top: 1px solid var(--color-background-secondary);
`

export default ResultItemStyled
